import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { BuildingOffersList } from 'src/features/building';
import { PrivateHat } from 'src/layout/private-hat';

export const MyBuildingOffersPage: FC = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <PrivateHat title={t('offers_title')} backIconText={t('back_cta')} />
            <BuildingOffersList />
        </Fragment>
    );
};
